import { useRef, useState } from 'react'
import { useAppStore } from '@/shared/store'
import Config from '@/shared/config/config'
import { getConfigRepository } from '@/shared/getContainer/getConfigRepository'
import theme from '@/clients/streamiq/app/theme/theme'

const ConfigRepository = await getConfigRepository()
const configRepository = ConfigRepository.Instance

export const useConfigStreamIQ = () => {
    const isSkinSet = useRef(false)

    const {
        setAppSkin,
        termsAndConditions,
        setTermsAndConditions,
        setFaq,
        setTAndC,
    } = useAppStore()

    const [isConfigFetched, setIsConfigFetched] = useState(false)

    const getAndSaveAppSkinToStore = (config: Config | null | undefined) => {
        if (config) {
            const { skin } = config
            setAppSkin(skin)
        }
    }

    const getAndSaveTermsToStoreIfNeed = (
        config: Config | null | undefined
    ) => {
        if (config && !termsAndConditions.url && !termsAndConditions.version) {
            const { version, url } = config.termsAndConditions ?? {}
            setTermsAndConditions({
                isTermsAccepted: false,
                version,
                url,
            })
        }
    }

    const takeConfigIfNeed = async () => {
        const previousLocalConfig = configRepository.getLocalConfig()

        isSkinSet.current = false

        if (previousLocalConfig) {
            isSkinSet.current = true
        }

        const config = await configRepository.takeConfigIfNeed()
        if (config) {
            setAppSkin(config.skin)
            getAndSaveAppSkinToStore(previousLocalConfig)
            setFaq(config.faqUrl)
            setTAndC(config.privacyPolicyUrl)
            getAndSaveTermsToStoreIfNeed(previousLocalConfig)
            isSkinSet.current = true

            if (config.skin.mainColor) {
                theme.palette.primary.main = config.skin.mainColor
            }
            if (config.skin.secondaryColor) {
                theme.palette.secondary.main = config.skin.secondaryColor
            }
        }

        setIsConfigFetched(true)
    }

    return {
        isConfigFetched,
        isSkinSet: isSkinSet.current,
        takeConfigIfNeed,
    }
}
